import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { TiimStudyParticipant } from '../../../../models/tiim-study-participant';

export const getTiimStudyParticipants = createAction(
  '[TiimStudyParticipants] Get TIIM Study Participants',
  props<{ studyId: number }>()
);

export const getTiimStudyParticipantsSuccess = createAction(
  '[TiimStudyParticipants] Get TIIM Study Participants Success',
  props<{ tiimStudyParticipants: TiimStudyParticipant[] }>()
);

export const getTiimStudyParticipantsError = createAction(
  '[TiimStudyParticipants] Get TIIM Study Participants Error',
  props<{ error: HttpErrorResponse }>()
);

export const deleteTiimStudyParticipant = createAction(
  '[TiimStudyParticipants] Delete TIIM Study Participant',
  props<{
    studyId: number;
    participantId: number;
    tiimStudyParticipantId: number;
  }>()
);

export const deleteTiimStudyParticipantSuccess = createAction(
  '[TiimStudyParticipants] Delete TIIM Study Participant Success',
  props<{ deletedTiimStudyParticipantId: number }>()
);

export const deleteTiimStudyParticipantError = createAction(
  '[TiimStudyParticipants] Delete TIIM Study Participant Error',
  props<{ error: HttpErrorResponse }>()
);

export const setSelectedTiimStudyParticipant = createAction(
  '[TiimStudyParticipants] Set Selected TIIM Study Participant',
  props<{ selectedTiimStudyParticipant: TiimStudyParticipant }>()
);

export const setSingleTiimStudyParticipantPageVisibility = createAction(
  '[TiimStudyParticipants] Set Single TIIM Study Participant Visibility',
  props<{ singleParticipantVisible: boolean }>()
);

export const sendTiimStudyParticipantNotification = createAction(
  '[TiimStudyParticipants] Send TIIM Study Participant Notification',
  props<{ participantId: number; message: string }>()
);

export const sendTiimStudyParticipantNotificationSuccess = createAction(
  '[TiimStudyParticipants] Send TIIM Study Participant Notification Success'
);

export const sendTiimStudyParticipantNotificationError = createAction(
  '[TiimStudyParticipants] Send TIIM Study Participant Notification Error',
  props<{ error: HttpErrorResponse }>()
);

export const enrolTiimStudyParticipant = createAction(
  '[TiimStudyParticipants] Enrol TIIM Study Participant',
  props<{ tiimStudyParticipant: TiimStudyParticipant }>()
);

export const enrolTiimStudyParticipantSuccess = createAction(
  '[TiimStudyParticipants] Enrol TIIM Study Participant Success',
  props<{ enrolledTiimStudyParticipant: TiimStudyParticipant }>()
);

export const enrolTiimStudyParticipantError = createAction(
  '[TiimStudyParticipants] Enrol TIIM Study Participant Error',
  props<{ error: HttpErrorResponse }>()
);
